export default {
  components: {},
  data () {
    return {
      inputWith: 12,
      formRules: {
        relationship_type: [
          {required: true, message: '客户关系类型不能为空', trigger: 'blur'},
        ],
        mail_post_time: [
          {validator: this.pushtimeValidator, trigger: 'blur'},
        ],
      },
      id: 0,
      form: {
        name: '',
        number: '',
        relationship_type: '',
        mail_post_time: '',
        contactors: [],
        buyers: [],
        mainContactors: [
          {
            name: '',
            job_title: '',
            email: '',
            phone: '',
          }
        ],
      },
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.customer.options,
    }),
  },
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data())
      this.onLoad()
    },
    setForm (id) {
      request.page('getCustomerRelationshipDetail', {id}).then(({data}) => {
        if (data.mail_post_time === '0000-00-00 00:00:00') {
          data.mail_post_time = ''
        } else {
          data.mail_post_time = moment(data.mail_post_time).format('YYYY-MM-DD')
        }
        filter.setLoop(this.form, data)
      })
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid && this.id) {
          if (!this.checkSubmit()) return

          this.update(this.id)
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    update (id) {
      request.common('updateCustomerRelationshipData', {id, ...this.form}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
          this.$router.push({name: '客户列表'})
        })
      })
    },
    onAddContactor () {
      let params = {
        name: '',
        email: '',
        phone: '',
        id: '',
        type: 1
      }
      this.form.contactors.push(params)
    },
    onAddBuyer () {
      let params = {
        name: '',
        email: '',
        phone: '',
        id: '',
        type: 2
      }
      this.form.buyers.push(params)
    },
    onDelContactor (index) {
      this.form.contactors.splice(index, 1)
    },
    onDelBuyer (index) {
      this.form.buyers.splice(index, 1)
    },


    // 验证潜在客户 推送时间
    pushtimeValidator (rule, value, callback) {
      if (!this.form.mail_post_time && this.form.relationship_type === '3') {
        callback(new Error('发送时间不能为空'))
      } else {
        callback()
      }
    },
    // 检查活动通用字段
    checkSubmit () {
      if (this.form.relationship_type !== '3') {
        delete this.form.mail_post_time
      }
      if (this.form.contactors.length > 4) {
        this.$message.error('项目对接人不能超过5个')
        return false
      }
      let isPass = this.checkMainContactors(this.form.mainContactors)
      if (!isPass) {
        return false
      }

      if (this.form.buyers.length > 5) {
        this.$message.error('客户采购不能超过5个')
        return false
      }
      for (let i = 0; i < this.form.contactors.length; i++) {
        let isPass = this.checkContact(this.form.contactors[i].name, this.form.contactors[i].phone, this.form.contactors[i].email)
        if (!isPass) {
          return false
        }
      }
      for (let i = 0; i < this.form.buyers.length; i++) {
        let isPass = this.checkContact(this.form.buyers[i].name, this.form.buyers[i].phone, this.form.buyers[i].email)
        if (!isPass) {
          return false
        }
      }
      return true
    },
    checkMainContactors (mainContactors) {
      for (const i in mainContactors) {
        const one = mainContactors[i]
        if (!this.checkContact(one.name, one.phone, one.email)) {
          return false
        }
      }
      return true
    },
    checkContact (name, phone, email) {
      if (!name) {
        this.$message.error('客户联系人不能为空')
        return false
      }
      if (!phone) {
        this.$message.error('联系方式不能为空')
        return false
      }
      if ((!(/^[1]\d{10}$/).test(phone)) || !phone.length === 11) {
        this.$message.error('联系方式不符合规范')
        return false
      }
      if (!email) {
        this.$message.error('邮箱不能为空')
        return false
      }
      if (!(/^([.a-zA-Z0-9_-])+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/).test(email)) {
        this.$message.error('邮箱格式不符合规范')
        return false
      }
      return true
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/customer/pages/CustomerRelationshipForm.js